import { create } from "zustand";

const STORAGE_KEY = "calendarPanelVisible";

function loadInitialVisible(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw === null ? true : raw === "true";
  } catch {
    return true;
  }
}

type CalendarPanelState = {
  visible: boolean;
  toggle: () => void;
};

export const useCalendarPanelStore = create<CalendarPanelState>((set, get) => ({
  visible: loadInitialVisible(),
  toggle: () => {
    const next = !get().visible;
    try {
      localStorage.setItem(STORAGE_KEY, String(next));
    } catch {
      // ignore
    }
    set({ visible: next });
  },
}));
